import { isMasterCatalog } from '../../../utils/catalog/catalog';
import {
  CATALOG_TYPE_ROOMS,
  CATALOG_TYPE_STORE,
  CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS,
  CATALOG_TYPE_THEMES,
} from '../../../utils/types/catalogTypes';
import { PANE_SOURCETREE, PANE_TARGETTREE } from '../../constants/panes';
import { selectCatalog, selectCatalogs } from '../../slices/catalog';
import { setSource, toggleActivePane } from '../../slices/pane';

export const selectSourceTree = (pane, catalogId) => async (dispatch, getState) => {
  const state = getState();
  const source = selectCatalog(state, catalogId);
  if (!source) {
    return undefined;
  }

  if (
    [CATALOG_TYPE_ROOMS, CATALOG_TYPE_STORE].includes(source.catalogType) &&
    pane === PANE_TARGETTREE
  ) {
    const catalogs = selectCatalogs(state);
    const productMaster = catalogs.find((f) => isMasterCatalog(f, 'ACTIVE'));

    dispatch(setSource({ pane: PANE_SOURCETREE, source: productMaster }));
    dispatch(toggleActivePane(null));
  }

  if (source.catalogType === CATALOG_TYPE_THEMES && pane === PANE_TARGETTREE) {
    const catalogs = selectCatalogs(state);
    const itemCategoryRecommendations = catalogs.find(
      (f) => f.catalogType === CATALOG_TYPE_ITEMS_CATEGORY_RECOMMENDATIONS,
    );

    if (itemCategoryRecommendations) {
      dispatch(
        setSource({ pane: PANE_SOURCETREE, source: itemCategoryRecommendations }),
      );
      dispatch(toggleActivePane(null));
    }
  }

  return dispatch(setSource({ pane, source }));
};
